import { ArticleStatus } from "entities/manageArticles/types";

export const statusTitles = {
  [ArticleStatus.PUBLISHED]: "Active",
  [ArticleStatus.UNPUBLISHED]: "Inactive",
};
